import { JsonUtils } from '../../utils/json.util'

export class Report {

    private _age_list: any | undefined
    private _average_age: number | undefined
    private _case_type: any | undefined
    private _county: any | undefined
    private _follow_ups_total: number | undefined
    private _registered_patients: number | undefined
    private _risk_factors: any | undefined
    private _stage_types: any | undefined
    private _standard_deviation: number | undefined

    get age_list(): any | undefined {
        return this._age_list
    }
    set age_list(value: any | undefined) {
        this._age_list = value
    }

    get average_age(): number | undefined {
        return this._average_age
    }
    set average_age(value: number | undefined) {
        this._average_age = value
    }

    get case_type(): any | undefined {
        return this._case_type
    }
    set case_type(value: any | undefined) {
        this._case_type = value
    }

    get county(): any | undefined {
        return this._county
    }
    set county(value: any | undefined) {
        this._county = value
    }
    get follow_ups_total(): number | undefined {
        return this._follow_ups_total
    }
    set follow_ups_total(value: number | undefined) {
        this._follow_ups_total = value
    }
    get registered_patients(): number | undefined {
        return this._registered_patients
    }
    set registered_patients(value: number | undefined) {
        this._registered_patients = value
    }
    get risk_factors(): any | undefined {
        return this._risk_factors
    }
    set risk_factors(value: any | undefined) {
        this._risk_factors = value
    }
    get stage_types(): any | undefined {
        return this._stage_types
    }
    set stage_types(value: any | undefined) {
        this._stage_types = value
    }
     get standard_deviation(): number | undefined {
        return this._standard_deviation
    }
    set standard_deviation(value: number | undefined) {
        this._standard_deviation = value
    }


    public fromJSON(json: any): Report {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }


        if (json.age_list !== undefined) {
            this.age_list = json.age_list
        }
        if (json.average_age !== undefined) {
            this.average_age = json.average_age
        }
        if (json.case_type !== undefined) {
            this.case_type = json.case_type
        }
        if (json.county !== undefined) {
            this.county = json.county
        }
        if (json.follow_ups_total !== undefined) {
            this.follow_ups_total = json.follow_ups_total
        }
        if (json.registered_patients !== undefined) {
            this.registered_patients = json.registered_patients
        }
        if (json.risk_factors !== undefined) {
            this.risk_factors = json.risk_factors
        }
        if (json.stage_types !== undefined) {
            this.stage_types = json.stage_types
        }
 if (json.standard_deviation !== undefined) {
            this.standard_deviation = json.standard_deviation
        }

        return this
    }
    public toJSON(): any {
        return {
            age_list: this.age_list || undefined,
            average_age: this.average_age || undefined,
            case_type: this.case_type || undefined,
            county: this.county || undefined,
            follow_ups_total: this.follow_ups_total || undefined,
            registered_patients: this.registered_patients || undefined,
            risk_factors: this.risk_factors || undefined,
            stage_types: this.stage_types || undefined,
            standard_deviation: this.standard_deviation || undefined,
        }
    }
}